module.exports = __webpack_public_path__ + "img/7E8174_39444D_CECAA7_B3B49B-256px.b7796bac.png";